import Swiper from 'swiper/bundle';

// Initialize Swiper
const initSwiper = () => {
    // Initialize the logo carousel Swiper
    const logos = document.querySelectorAll('.logo-carousel');

    for (let i = 0; i < logos.length; i++) {
        logos[i].classList.add('logo-swiper-container-' + i);
        
        new Swiper('.logo-swiper-container-' + i + ' .logoSwiper', {
            loop: true,
            slidesPerView: 3,
            spaceBetween: 27,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 3000,
            breakpoints: {
                992: { slidesPerView: 4 },
                1200: { slidesPerView: 5 }
            },
        });
    }

    // Initialize the product Swiper
    const product = document.querySelectorAll('.product');

    for (let i = 0; i < product.length; i++) {
        product[i].classList.add('product-swiper-container-' + i);
        new Swiper('.product-swiper-container-' + i + ' .productSwiper', {
            slidesPerView: 1.2,
            spaceBetween: 32,
            navigation: {
                nextEl: '.product.product-swiper-container-' + i + ' .__next',
                prevEl: '.product.product-swiper-container-' + i + ' .__prev',
            },
            breakpoints: {
                768: { slidesPerView: 2.2 },
                1200: { slidesPerView: 3.2 }
            },
        });
    }

    // Initialize the signpost Swiper
    const signpost = document.querySelectorAll('.signpost.__swiper');

    for (let i = 0; i < signpost.length; i++) {
        signpost[i].classList.add('signpost-swiper-container-' + i);

        new Swiper('.signpost-swiper-container-' + i + ' .signpostSwiper', {
            slidesPerView: 1.5,
            spaceBetween: 16,
            pagination: {
                el: '.signpost-swiper-container-' + i + ' .swiper-progress',
                type: 'progressbar',
            },
            breakpoints: {
                640: { 
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                }
            },
        });
    }

    // Initialize the media Swiper
    const media = document.querySelectorAll('.media-gallery');

    for (let i = 0; i < media.length; i++) {
        media[i].classList.add('media-gallery-swiper-container-' + i);

        new Swiper('.media-gallery-swiper-container-' + i + ' .mediaSwiper', {
            slidesPerView: 1,
            loop: false,
            pagination: {
                el: '.media-gallery-swiper-container-' + i + ' .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '.media-gallery.media-gallery-swiper-container-' + i + ' .__next',
                prevEl: '.media-gallery.media-gallery-swiper-container-' + i + ' .__prev',
            },
        });
    }

    // Initialize the banner Swiper
    const banner = document.querySelectorAll('.banner-home');

    for (let i = 0; i < banner.length; i++) {
        banner[i].classList.add('banner-swiper-container-' + i);

        new Swiper('.banner-swiper-container-' + i + ' .bannerSwiper', {
            slidesPerView: 1,
            loop: false,
            pagination: {
                el: '.banner-swiper-container-' + i + ' .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '.banner-home.banner-swiper-container-' + i + ' .__next',
                prevEl: '.banner-home.banner-swiper-container-' + i + ' .__prev',
            },
        });
    }
};

export default initSwiper;